import { ApplicableProductScope, type DiscountTriggerMethod, type PromotionType } from '@hooks-api/types/dataModel/coupon'
import { type BaseAnalyticsEvent } from './events'

export const couponProductsType = {
  [ApplicableProductScope.ALL_PRODUCT]: '全館',
  [ApplicableProductScope.SPECIFIC_PRODUCT]: '單品',
  [ApplicableProductScope.WAREHOUSE_PRODUCT]: '單品',
} as const

export interface BasePromotionEvent extends BaseAnalyticsEvent {
  eventParams: {
    page_url: string
    coupon_id: number
    coupon_title: string
    coupon_products_type: string
    /**
     * 當為多個 criterion 時，會是 'A+B'
     */
    coupon_criterion_type: DiscountTriggerMethod | 'A+B'
    coupon_promotion_type: PromotionType
    /** NOTE: null 為無期限 */
    coupon_countdown_mins: number | null
  }
}

export interface ClickCouponCard extends BasePromotionEvent {
  eventName: 'click_coupon_card'
}
export interface ClickCouponPageBanner extends BasePromotionEvent {
  eventName: 'click_coupon_page_banner'
}
export interface OpenGiftDescription extends BasePromotionEvent {
  eventName: 'open_gift_description'
}
export interface CheckGiftCriterion extends BasePromotionEvent {
  eventName: 'check_gift_criterion'
}
export interface CheckAnBTab extends BasePromotionEvent {
  eventName: 'check_AnB_tab'
}
export interface OpenFooterCart extends BasePromotionEvent {
  eventName: 'open_footer_cart'
  eventParams: BasePromotionEvent['eventParams'] & {
    footer_cart_items: string
  }
}
export interface HideFooterCart extends BasePromotionEvent {
  eventName: 'hide_footer_cart'
  eventParams: BasePromotionEvent['eventParams'] & {
    footer_cart_items: string
  }
}
export interface GetAClaimableCoupon extends BaseAnalyticsEvent {
  eventName: 'get_a_claimable_coupon'
}
export interface GetAllClaimableCoupon extends BaseAnalyticsEvent {
  eventName: 'get_all_claimable_coupon'
}

export type WordpressPromotionEvents =
  ClickCouponCard |
  ClickCouponPageBanner |
  OpenGiftDescription |
  CheckGiftCriterion |
  CheckAnBTab |
  OpenFooterCart |
  HideFooterCart |
  GetAClaimableCoupon |
  GetAllClaimableCoupon

export type PromotionEventNames = WordpressPromotionEvents['eventName']
